export function stickyElement() {
    let $header = $(".header");
    let $parent = $(".article");
    let $stickyEl = $parent.find(".sharing");
    let $stickyElHolder = $stickyEl.find(".inner");
    let windowTop;

    function sticky() {
        windowTop = $(window).scrollTop();
        let $stickyElTop = $stickyEl.offset().top;
        let $headerHeight = $header.innerHeight();
        let $parentHeight = $parent.innerHeight();
        let $parentTop = $parent.offset().top;
        let $stickyElHolderHeight = $stickyElHolder.innerHeight();
        if (windowTop > $stickyElTop - $headerHeight - 20 && window.innerWidth >= 1024) {
            $stickyElHolder.css({
                position: "fixed",
                top: $headerHeight + 20,
            });
        }
        if (windowTop > ($parentHeight + $parentTop - $stickyElHolderHeight - $headerHeight - 20) && window.innerWidth >= 1200) {
            $stickyElHolder.css({
                position: "absolute",
                top: $parentHeight - $stickyElHolderHeight
            });
        }
        if (windowTop < $stickyElTop - $headerHeight - 20 || window.innerWidth < 1200) {
            $stickyElHolder.attr("style", "");
        }
    }

    $(window).on("load scroll", function () {
        sticky();
    });

    $(".article-sidebar button").on("click", function () {
        if ($parent.find(".form-holder")) {
            $("html, body").animate({scrollTop: $parent.find(".form-holder").offset().top - $header.innerHeight()}, 1000);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyElement.js